export default {
  common__validation__is_required: 'Campo é obrigatório',
  common__validation__invalid_format: 'Valor incorreto',
  common__validation__invalid_file_size: 'O tamanho do arquivo excede o limite máximo ({size})',
};
